import { useFormik } from "formik";
import {
  formikSetup,
  formikValidation,
  initialValues,
  validationSchema,
} from "../formikValidation";
import TextArea from "../../sharedComponents/textarea/textArea";
import TextInput from "../../sharedComponents/inputs/textInput";
import {
  customStyle,
  styleEnd,
  styleStart,
} from "../../../algorithms/styleDirection";
import Button from "../../sharedComponents/buttons/button";
import { useEffect, useRef, useState } from "react";
import Lang from "../../../userPreferences/staticWords";
import DateInput from "../../sharedComponents/datesInputs/date";
import DropDownList from "../../sharedComponents/dropdown/dropdown";
import { editTaskForm } from "../../../API/store/actions/tasks";
import { useSelector } from "react-redux";
import "../tasksStyle.css";
import MembersList, { removeItem } from "../../../algorithms/listsAlogrithms";
import { englishDate } from "../../../algorithms";
import { resolver } from "../../../API/middlewares/resolveRequests";
import { getCommunitiesWithPermssions } from "../../../API/store/actions/community";
import {
  loadCommunitiesWithSectors,
  loadSectors,
} from "../../../API/services/utilities";

const EditTaskForm = ({
  taskId,
  setVisible,
  data,
  setProcAdded,
  procAdded,
  userToken,
}) => {
  const communityId = useSelector((state) => state.community.communityId?.id);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const user = useSelector((state) => state.login.userData);

  const saveHandler = async (values) => {
    try {
      setIsSubmitting(true);
      let startDate = values.StartDate?.toString().includes("T0")
        ? values.StartDate
        : englishDate(values.StartDate) + "T00:00:00";
      let endDate = values.EndDate?.toString()?.includes("T0")
        ? values.EndDate
        : englishDate(values.EndDate).toString() + "T00:00:00";
      let actualStartDate = values.ActualStartDate
        ? values.ActualStartDate?.toString().includes("T0")
          ? values.ActualStartDate
          : englishDate(values.ActualStartDate) + "T00:00:00"
        : "";
      let actualEndDate = values.ActualEndDate
        ? values.ActualEndDate?.toString()?.includes("T0")
          ? values.ActualEndDate
          : englishDate(values.ActualEndDate).toString() + "T00:00:00"
        : "";
      const formData = new FormData();
      let newData = {
        OwnerId: user.id,
        NameA: values.Name,
        NameE: values.Name,
        DescriptionA: values.Description,
        DescriptionE: values.Description,
        StartDate: startDate,
        EndDate: endDate,
        ActualStartDate: actualStartDate,
        ActualEndDate: actualEndDate,
        EstimatedTime: values.EstimatedTime
          ? parseInt(values.EstimatedTime)
          : 0,
        CreateDate: values.CreateDate ? values.CreateDate : undefined,
        PriorityId: parseInt(values.PriorityId),
        TaskStatusId: parseInt(values.TaskStatusId),
        ExecutionPercentage: values.ExecutionPercentage
          ? parseInt(values.ExecutionPercentage)
          : 0,
        AdminTaskMembers: values.AdminTaskMembers,
        memberIds: values.TaskMembers,
        Id: parseInt(taskId),
        typeId: parseInt(values.typeId),

        CommunityId: parseInt(values.CommunityId),
        AccessLevelId: parseInt(values.AccessLevelId),
        // CountrisId: values?.Countries,
        CountrisId: values?.CountrisId,
        ImplementRequirementId: parseInt(values?.TaskImplementRequirementId),
      };
      if (!values.ActualStartDate) delete newData.ActualStartDate;
      if (!values.ActualEndDate) delete newData.ActualEndDate;
      if (!values.CommunityId) delete newData.CommunityId;
      if (!values.AccessLevelId) delete newData.AccessLevelId;

      for (let [key, value] of Object.entries(newData)) {
        if (key == "memberIds") {
          value.forEach((element) => {
            formData.append("memberIds", element);
          });
        } else if (key == "CountrisId") {
          value.forEach((element) => {
            formData.append("CountrisId", element);
          });
        } else {
          formData.append(key, value);
        }
      }

      if (startDateError === false && endDateError === false) {
        // if (values.AdminTaskMembers.length > 0) {
        //   setAdminListError(false);
        let res = await editTaskForm(formData, userToken);
        if (res.status <= 206) {
          setVisible(false);
          setProcAdded(!procAdded);
        } else {
          setErrorMessage("حدث خطأ");
        }
      }
    } catch (error) {
      setErrorMessage("حدث خطأ");
    } finally {
      setIsSubmitting(false);
    }
  };

  const formik = useFormik(
    formikSetup(
      initialValues,
      data,
      validationSchema,
      "editPopup",
      saveHandler,
    ),
  );
  const {
    errors,
    touched,
    handleSubmit,
    setFieldValue,
    values,
    setFieldTouched,
    handleChange,
  } = formik;

  const [communityData, setCommunityData] = useState();

  const [sectors, setSectors] = useState(null);
  const [sectorId, setSectorId] = useState(values.SectorId);
  const [communitiesWithSectors, setCommunitiesWithSectors] = useState(null);
  useEffect(() => {
    resolver(
      getCommunitiesWithPermssions,
      setCommunityData,
      1,
      1000,
      userToken,
    );
    resolver(loadSectors, setSectors, userToken);
  }, []);

  useEffect(() => {
    resolver(
      loadCommunitiesWithSectors,
      setCommunitiesWithSectors,
      sectorId,
      userToken,
    );
  }, [sectorId]);

  const communityTaskForm = useSelector(
    (state) => state.tasks.getCommunityTaskForm,
  );
  const [TaskStatusDropdownList, setTaskStatusDropdownList] = useState(
    communityTaskForm?.data?.taskStatusLkp,
  );
  const [PriorityDropdownList, setPriorityDropdownList] = useState(
    communityTaskForm?.data?.priorityLkp,
  );

  const [startDateError, setStartDateError] = useState(false);
  const [endDateError, setEndDateError] = useState(false);
  const [actualStartDateError, setActualStartDateError] = useState(false);
  const [actualEndDateError, setActualEndDateError] = useState(false);
  const [adminListError, setAdminListError] = useState(false);
  const [taskType, setTaskTypeLists] = useState(
    communityTaskForm?.data?.taskType,
  );

  const [AdminTaskMembersList, setAdminTaskMembersList] = useState([
    ...communityTaskForm?.data?.members,
  ]);

  const [TaskMembersList, setTaskMembersList] = useState([
    ...communityTaskForm?.data?.members?.filter(
      (member) => member?.memberId !== values.AdminTaskMembers,
    ),
  ]);
  const [CountriesList, setCountriesList] = useState([
    ...communityTaskForm?.data?.countryLkp?.filter(
      (member) => !values.CountrisId.some((country) => country == country.id),
    ),
  ]);
  const [communities, setCommunitiesList] = useState();
  useEffect(() => {
    resolver(
      getCommunitiesWithPermssions,
      setCommunitiesList,
      1,
      1000,
      userToken,
    );
  }, []);
  //countries;
  const [countries, setCountries] = useState([]);
  return (
    <form onSubmit={handleSubmit}>
      <TextArea
        name={"Name"}
        containerStyle={"mb-4 col-12 align-items-center"}
        placeholder={Lang.title + "*"}
        rows="3"
        contentStyle={`scroll col-11 p-1`}
        onChange={handleChange}
        value={values.Name}
        errorMessage={formikValidation(touched, errors, "Name")}
      />
      <TextArea
        name={"Description"}
        containerStyle={"mb-4 col-12 align-items-center"}
        placeholder={Lang.Description}
        rows="3"
        contentStyle={`scroll col-11 p-1`}
        onChange={handleChange}
        value={values.Description}
        errorMessage={formikValidation(touched, errors, "Description")}
      />
      <div
        className="d-flex flex-xl-row justify-content-center align-items-end col-12 flex-column mt-4 mx-3"
        style={{ width: "95.4%" }}
      >
        <DropDownList
          placeholder={Lang.communities}
          border={true}
          containerStyle={`col-12 mb-3 mb-xl-1 col-xl-6 mx-0 ps-4 pe-4`}
          dataSource={communityData?.data}
          value={values.CommunityId}
          // disabled={values.SectorId == "" ? true : false}
          // enabled={values.SectorId == "" ? false : true}
          change={(e) => {
            setFieldValue("CommunityId", e.value);
          }}
          errorMessage={formikValidation(touched, errors, "CommunityId")}
        />{" "}
        <DropDownList
          placeholder={Lang.types}
          border={true}
          containerStyle={`col-12 mb-3 mb-xl-1 col-xl-6 mx-0 ps-2 pe-2`}
          dataSource={communityTaskForm?.data?.accessLevelLkp}
          value={values?.AccessLevelId}
          // disabled={values.SectorId == "" ? true : false}
          // enabled={values.SectorId == "" ? false : true}
          change={(e) => {
            setFieldValue("AccessLevelId", e.value);

            const allCountries =
              communityTaskForm?.data?.countryLkp?.map((c) => c.id) || [];

            if (e.value == 2) {
              setFieldValue("CountrisId", allCountries);
            } else {
              setFieldValue("CountrisId", []);
            }
          }}
          errorMessage={formikValidation(touched, errors, "AccessLevelId")}
        />
      </div>
      <div
        className="d-flex flex-xl-row justify-content-center align-items-end col-12 flex-column mt-4"
        style={{ width: "98%", padding: "0 20px" }}
      >
        <DropDownList
          placeholder={Lang.priority + "*"}
          border={true}
          containerStyle={`col-12 mb-3 mb-xl-1 col-xl-6 mx-0 ps-4 pe-4 mx-1`}
          dataSource={PriorityDropdownList}
          value={values.PriorityId}
          change={(e) => {
            setFieldValue("PriorityId", e.value);
          }}
          errorMessage={formikValidation(touched, errors, "PriorityId")}
        />

        <DropDownList
          placeholder={Lang.taskStatus + "*"}
          border={true}
          containerStyle={`col-12 mb-3 mb-xl-1 col-xl-6 mx-0 ps-2 pe-2 `}
          dataSource={TaskStatusDropdownList}
          value={values.TaskStatusId}
          change={(e) => {
            setFieldValue("TaskStatusId", e.value);
          }}
          errorMessage={formikValidation(touched, errors, "TaskStatusId")}
        />
      </div>
      {/* add procedure requirments dropdown start*/}
      <div className="d-flex flex-xl-row justify-content-center align-items-end col-12 flex-column mt-4">
        <DropDownList
          placeholder={"تطلبات تنفيذ الإجراء"}
          border={true}
          containerStyle={`col-12 mb-3 mb-xl-1 col-xl-6 pe-xl-5 ps-xl-2 ps-4 pe-4`}
          dataSource={communityTaskForm?.data?.implementRequirement}
          value={values.TaskImplementRequirementId}
          change={(e) => {
            setFieldValue("TaskImplementRequirementId", e.value);
          }}
          errorMessage={formikValidation(
            touched,
            errors,
            "TaskImplementRequirementId",
          )}
        />
        <DropDownList
          placeholder="طبيعة الإجراء"
          border={true}
          dataSource={taskType}
          containerStyle={`col-12 mb-1 col-xl-6 ps-xl-5 pe-xl-2 ps-4 pe-4`}
          value={values.typeId}
          change={(e) => {
            setFieldValue("typeId", e.value);
          }}
          errorMessage={formikValidation(touched, errors, "typeId")}
        />
      </div>
      {/* add procedure requirments dropdown end*/}
      <div className="data-wrapper mt-3 ">
        <p className="px-3 px-xl-5 col-12">{"التاريخ المخطط"}</p>
        <div className="row " style={{ padding: "0 50px" }}>
          <div className={`col-12 col-xl-6 `}>
            <div style={{ width: "96%" }}>
              {" "}
              <DateInput
                inputStyle={"upperZIndex"}
                errorMessage={
                  formikValidation(touched, errors, "StartDate") ||
                  startDateError === true
                    ? Lang.invalidDate
                    : null
                }
                placeholder={Lang.from}
                containerStyle={`col-12 col-xl-11 ${styleStart("m", 3, "xl")}`}
                name={"StartDate"}
                value={values.StartDate}
                onChange={(e) => {
                  setFieldValue("StartDate", e);
                  if (values.EndDate)
                    if (new Date(values.EndDate) >= new Date(e)) {
                      setEndDateError(false);
                      setStartDateError(false);
                    } else setStartDateError(true);
                }}
                iconPrefix="far"
                iconName="calendar"
                iconSize={22}
              />
            </div>
          </div>

          <div className={`col-12 col-xl-6 `}>
            <div style={{ width: "100%" }}>
              {" "}
              <DateInput
                inputStyle={"upperZIndex"}
                errorMessage={
                  formikValidation(touched, errors, "EndDate") ||
                  endDateError === true
                    ? Lang.invalidDate
                    : null
                }
                placeholder={Lang.to}
                containerStyle={`col-12 col-xl-11 ${styleStart("m", 3, "xl")}`}
                value={values.EndDate}
                onChange={(e) => {
                  setFieldValue("EndDate", e);
                  if (values.StartDate)
                    if (new Date(values.StartDate) <= new Date(e)) {
                      setEndDateError(false);
                      setStartDateError(false);
                    } else setEndDateError(true);
                }}
                iconPrefix="far"
                iconName="calendar"
                iconSize={22}
              />
            </div>
            {/* {endDateError === true ? (
                    <div>
                      <p className="my-2 text-danger">{Lang.invalidDate}</p>
                    </div>
                  ) : null} */}
          </div>
        </div>
      </div>
      <DropDownList
        placeholder={Lang.MainAdminMembers}
        border={true}
        containerStyle={"my-4 col-11 align-items-center mx-auto "}
        dataSource={
          AdminTaskMembersList?.map((item) => ({
            id: item.memberId,
            name: item.memberName,
          })) || []
        }
        value={values.AdminTaskMembers ?? undefined}
        change={(e) => {
          const selectedId = e.value;

          setFieldValue("AdminTaskMembers", selectedId);

          setTaskMembersList(
            TaskMembersList.filter(
              (item) => parseInt(item.memberId) !== parseInt(selectedId),
            ),
          );

          setAdminListError(false);
        }}
        errorMessage={
          touched.AdminTaskMembers && errors.AdminTaskMembers
            ? Lang.require
            : ""
        }
      />
      <MembersList
        containerStyle="d-flex flex-column mx-xl-4 mx-3 mb-4 col-12"
        aboveTitleStyle={`d-flex px-3 col-11 mb-3 ${styleStart("m", 2)}`}
        aboveTitle={Lang.addSharedAdmainMembers}
        cardStyle={`d-flex flex-column col-11 px-3 py-2 mx-1 mx-lg-3 mx-xl-4 ${customStyle(
          "TitleCard",
        )}`}
        cardTitle={Lang.adminMembers}
        id={"A"}
        list={TaskMembersList}
        checked={true}
        // values={values.AdminTaskMembers}
        values={values.TaskMembers}
        onChange={(e) => {
          const selectedId = parseInt(e.target.value);

          if (e.target.checked) {
            setFieldValue("TaskMembers", [...values.TaskMembers, selectedId]);
          } else {
            setFieldValue(
              "TaskMembers",
              values.TaskMembers.filter((x) => x !== selectedId),
            );
          }
        }}
        // listError={adminListError}
      />
      <MembersList
        containerStyle="d-flex flex-column mx-xl-4 mx-3 mb-4 col-12"
        aboveTitleStyle={`d-flex px-3 col-11 mb-3 ${styleStart("m", 2)}`}
        aboveTitle={"إضافة دول"}
        cardStyle={`d-flex flex-column col-11 px-3 py-2 mx-1 mx-lg-3 mx-xl-4 ${customStyle(
          "TitleCard",
        )}`}
        list={communityTaskForm?.data?.countryLkp}
        id={"B"}
        checked={true}
        values={values?.CountrisId || []}
        target={true}
        onChange={(e) => {
          setFieldTouched("CountrisId", true);

          const countryId = parseInt(e.target.id);
          const accessLevel = Number(values.AccessLevelId);

          // Access Level = 1 => only one country
          if (accessLevel === 1) {
            if (e.target.checked) {
              setFieldValue("CountrisId", [countryId]);
            } else {
              setFieldValue("CountrisId", []);
            }
            return;
          }

          // Access Level = 2 => all countries selected, prevent editing
          if (accessLevel === 2) {
            return;
          }

          // Other Access Levels => multiple countries allowed
          if (e.target.checked) {
            setFieldValue("CountrisId", [...values.CountrisId, countryId]);
          } else {
            setFieldValue(
              "CountrisId",
              values.CountrisId.filter((id) => id !== countryId),
            );
          }
        }}
        listError={touched.CountrisId && errors.CountrisId}
        disabled={Number(values.AccessLevelId) === 2}
      />
      <div className="d-flex flex-sm-row justify-content-center mt-5 mb-3 col-12">
        <Button
          content={isSubmitting ? Lang.isSaving : Lang.save}
          containerStyle="col-3 mx-3"
          onClick={() => {
            if (values.AdminTaskMembers.length > 0) setAdminListError(false);
            else setAdminListError(true);
          }}
          type={"submit"}
          buttonStyleType={"solid"}
          disable={isSubmitting}
        />

        <Button
          content={Lang.cancel}
          containerStyle="col-3 mx-3"
          onClick={() => {
            // setPriorityDropdownList(communityTaskForm.priorityLkp);
            // setTaskStatusDropdownList(communityTaskForm.taskStatusLkp);
            // resetForm();
            // setError(false);
            setAdminListError(false);
            setVisible(false);
          }}
        />
      </div>{" "}
      {errorMessage && (
        <div className="text-danger text-center my-3">{errorMessage}</div>
      )}
    </form>
  );
};
export default EditTaskForm;
